import { render } from "./endPiece.vue?vue&type=template&id=6cd59034&scoped=true"
import script from "./endPiece.vue?vue&type=script&lang=js"
export * from "./endPiece.vue?vue&type=script&lang=js"

import "./endPiece.vue?vue&type=style&index=0&id=6cd59034&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd59034"]])

export default __exports__